module.exports = __webpack_public_path__ + "static/media/amex.b8c8a1a2.svg";